import { Typography } from '@mui/material'
import type { ReactNode } from 'react'

const DEFAULT_VARIANT = 'subtitle3'
const DEFAULT_COLOR = 'text.secondary'

const ALTERNATIVE_VARIANT = 'subtitle1'
const ALTERNATIVE_COLOR = 'text.secondary'

export interface SectionTitleProps {
  children: ReactNode
  variant?: 'default' | 'alternative'
}

export function SectionTitle(props: SectionTitleProps) {
  const { children, variant = 'default' } = props
  const typographyVariant = variant === 'default' ? DEFAULT_VARIANT : ALTERNATIVE_VARIANT
  const typographyColor = variant === 'default' ? DEFAULT_COLOR : ALTERNATIVE_COLOR

  return (
    <Typography variant={typographyVariant} color={typographyColor}>
      {children}
    </Typography>
  )
}
